<template>
  <div id="coupon" class="coupon" v-if="isShowCoupon || isShowInformationForm || isShowQrCode">
    <!-- 1.优惠券 -->
    <div v-if="isShowCoupon">
        <div id="coupon-pic" class="coupon-pic" style="margin-bottom: 0px">
          <img :src="couponPackage.image"  class="pic"/>
            <img src="../../assets/pic/delete.png" class="delete-pic" @click="close"/>
            <img src="../../assets/pic/gain-coupon.png" class="gain-coupon size-change" @click="gainCoupon"/>
        </div>
    </div>
    <!-- 2.填报信息 -->
    <div>
        <div class="coupon-information" v-if="isShowInformationForm">
      <div class="coupon-order">
        <div class="element-row" style="height: 54px">
          <div
            class="element-col-simple"
            style="height: 54px;"
          >
            <span class="txt request">公司名称</span>
            <el-input
              v-model="couponForm.companyName"
              placeholder="公司名称"
              style="display: inline"
            ></el-input>
          </div>
        </div>
        <div class="element-row" style="height: 54px">
          <div
            class="element-col-simple"
            style="height: 54px;"
          >
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span class="txt request">联系人</span>
            <el-input
              v-model="couponForm.contact"
              placeholder="联系人"
              style="display: inline"
            ></el-input>
          </div>
        </div>
        <div class="element-row" style="height: 54px">
          <div
            class="element-col-simple"
            style="height: 54px;"
          >
            <span class="txt request">联系电话</span>
            <el-input
              v-model.trim="couponForm.mobile"
              placeholder="联系电话"
              style="display: inline"
            ></el-input>
          </div>
        </div>
          <div
            class="element-row"
            style="height: 54px; padding-left: 29px; padding-right: 8px"
          >
          <div
            class="element-col-simple"
            style="height: 54px;"
          >
            <span class="txt request">验证码</span>
            <div class="sendCode">
              <el-input
                v-model="couponForm.verificationCode"
                placeholder="4位验证码"
                style="display: inline"
              ></el-input>
              <span
                class="txt2"
                :class="isPhoneNumber(couponForm.mobile) ? 'active-txt2' : ''"
                @click="sendSMS"
                >{{ smsCodeTime != 0 ? smsCodeTime : "短信验证" }}</span
              >
            </div>
            </div>
          </div>
        <div class="element-row">
          <div class="element-col element-col-span-8">
            <div
              class="coupon-button coupon-order-submit coupon-button-primary"
            >
              <button class="" @click="checkGainCoupon">确认</button>
            </div>
          </div>
        </div>
                <span
          class="coupon-order-close"
          @click="close"
          >×</span
        >
        </div>
        

    </div>  

        </div>
    <el-dialog
      class="qrcode-show"
      title="请微信扫码添加团建策划师，及时沟通更有效"
      :visible.sync="isShowQrCode"
      :before-close="close"
      :modal="false"
      width="280px"
    >
      <img
        id="qrCode"
        :src="
          basicInfo.customQrCode  
        "
        alt
      />
    </el-dialog>
    </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import {isPhoneNumber} from "../../util/util";
export default {
  name: "coupon",
  data() {
    return {
      // 是否展示优惠券
      isShowCoupon:false,
      // 是否展示信息填报
      isShowInformationForm:false,
      // 是否展示二维码
      isShowQrCode:false,
      // 填报表单
      couponForm:{
        couponSetupId:'',
        mobile:'',
        companyName:'',
        contact:'',
        verificationCode:'',
      },
      // 优惠券列表
      couponPackage:{
        id:'',
      },
      // 下一次可发短信倒计时
      smsCodeTime: 0,
      timer:"",

    };
  },
  computed: {
    basicInfo() {
      return this.$store.state.webInfo;
    },
  },
  methods: {
    isPhoneNumber,
    // 初始化
    init(){
      // 先查询cookies
      let result = localStorage.getItem("couponPackage");
      // cookies没有
      if(!result){
      axios
        .get(`/api/coupon/list`).then((res) => {
          if (res.data && res.data.code == 200 && res.data.data && res.data.data.length > 0) {
              this.couponPackage = res.data.data[0];
               this.isShowCoupon = true;
          }
        });
      }
    },
    // 点击领取
    gainCoupon() {
      this.resetForm();
      this.isShowCoupon = false;
      this.isShowInformationForm = true;
    },
    // 点击领取
    resetForm() {
      this.couponForm = {
        couponSetupId:this.couponPackage.id,
        mobile:'',
        verificationCode:'',
        companyName:'',
        contact:'',
      }
    },

    // 确认
    checkGainCoupon() {
      let { mobile, companyName, contact, verificationCode } = this.couponForm;
      if (!companyName || companyName.trim().length == 0) {
        this.$message({
          message: "请填写公司名称",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      if (!contact || contact.trim().length == 0) {
        this.$message({
          message: "请填写联系人",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      if (!mobile || mobile.length != 11) {
        this.$message({
          message: "请正确填写手机号码",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      if (!verificationCode) {
        this.$message({
          message: "请正确填写验证码",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      axios
        .post(`/api/coupon/gainCoupon`, JSON.stringify(this.couponForm), {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        })
        .then((res) => {
          let msg = "";
          if (res.data) {
            if (res.data.code == 200) {
               if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "领取成功";
                }
                this.isShowInformationForm = false;
                this.isShowQrCode = true;
                this.$message({
                  message: msg,
                  type: "success",
                  center: true,
                });
                // 存入优惠券信息
                localStorage.setItem("couponPackage", this.couponPackage);
                this.resetForm();
            } else {
              if (res.data.code == 500) {
                if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "领取失败";
                }
                this.$message({
                  message: msg,
                  type: "error",
                  duration: 1500,
                  center: true,
                });
              }
            }
          }
        });
    },
    // 发送短信
    sendSMS() {
      if(this.smsCodeTime>0 || !isPhoneNumber(this.couponForm.mobile)){
        return;
      }
      let params = { mobile: this.couponForm.mobile };
      axios
        .get(`/api/verificationCode/sendCode`, {
          params,
        })
        .then((res) => {
          if (res.data) {
            if (res.data.code == 200) {
              // 成功则重置短信验证码时间
              this.smsCodeTime = 60;
              this.smsDown();
            } else {
              if (res.data.code == 500) {
                let msg = "";
                if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "短信发送失败";
                }
                this.$message({
                  message: msg,
                  type: "warning",
                  duration: 1500,
                  center: true,
                });
              }
            }
          }
        });
    },
    // 短信计时器
    smsDown() {
      this.timer = setInterval(() => {
        if (this.smsCodeTime != 0) {
          this.smsCodeTime = this.smsCodeTime - 1;
        }
      }, 1000);
    },
    // 关闭
    close(){
      this.isShowCoupon = false;
      this.isShowInformationForm = false;
      this.isShowQrCode = false;
    }
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    if(this.timer){
      window.clearInterval(this.timer);
    }
  },
};
</script>

<style scoped>
#coupon {
  background: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 1001;
}

#coupon .coupon-pic {
  display: flex;
  position: relative;
  margin: 0 auto;
  top:200px;
  width: 633px;
  height: 465px;
}
.coupon-pic .pic{
  width: 100%;
  position: absolute;
  width: 633px;
  height: 465px;
}
.coupon-pic .delete-pic{
  width: 100%;
  position: absolute;
  width: 33px;
  height: 33px;
  right: 5px;
  top: 5px;
  cursor: pointer;
}
.coupon-pic .gain-coupon{
  width: 100%;
  position: absolute;
  width: 191px;
  height: 43px;
  bottom: 40px;
  right: 215px;
  cursor: pointer;
}
/* 放大缩小动画 */
@keyframes scaleDraw {
  /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/

  0% {
    transform: scale(1); /*开始为原始大小*/
  }

  25% {
    transform: scale(1.1); /*放大1.1倍*/
  }

  50% {
    transform: scale(1);
  }

  75% {
    transform: scale(1.1);
  }
}
.size-change{
    -webkit-animation-name: scaleDraw;
    -webkit-animation-timing-function: ease-in-out;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-duration: 5s;
}

#coupon .qrcode-show-background{
    position: fixed;
    right: 70px;
    /* bottom: 90px; */
    bottom: 162px;
    border-radius: 16px;
    box-shadow: 0 2px 10px 0 rgb(0 0 0 / 10%);
    width: 205px;
    height: 246px;
    background: #fff;
    background-size: cover;
    overflow: hidden;
    z-index: 1999;
}
#coupon .background-contact .close-button, .qrcode-show-background .close-button{
  position: absolute;
  top: 5px;
  right: 15px;
  color: #fff;
  cursor: pointer;
}
</style>
<style scoped>
.coupon {
  background: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 1001;
}
.coupon-order {
  position: absolute;
  top: 70%;
  left: 50%;
  background: #fff;
  border-radius: 14px;
  width: 616px;
  margin-top: -263px;
  margin-left: -308px;
  padding: 25px 51px;
}

.request::before {
  content: "*";
  color: red;
  position: relative;
}
.element-row,
.element-row:after,
.element-row:before {
  display: flex;
  justify-content: center;
}
.element-row {
  flex-flow: row wrap;
}
#coupon .coupon-order .coupon-order-close {
  display: block;
  width: 60px;
  height: 60px;
  position: absolute;
  top: 0;
  right: 0;
  line-height: 60px;
  text-align: center;
  font-size: 30px;
  cursor: pointer;
  border-radius: 0 14px 0 0;
  transition: all 0.2s ease-in-out;
}
.element-col-span-12 {
  display: block;
  flex: 0 0 50%;
  max-width: 50%;
}
.element-col {
  position: relative;
  max-width: 100%;
  min-height: 1px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}
.element-col-simple {
  position: relative;
  max-width: 100%;
  min-height: 1px;
  display: flex;
  flex-wrap: nowrap;
  justify-items: flex-start;
  align-items: center;
}
.element-col-canwrap {
  position: relative;
  max-width: 100%;
  min-height: 1px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.coupon .coupon-order .coupon-order-submit {
  margin-top: 30px;
}
.coupon-button-primary {
  background: #222;
}
.coupon-button {
  width: 100%;
  position: relative;
  font-weight: 700;
  font-size: 16px;
  color: #fff;
  letter-spacing: 1.6px;
  text-align: center;
  border-radius: 2px;
  height: 44px;
}
.element-col-push-8 {
  left: 33.33333333%;
}
.element-col-span-8 {
  display: block;
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}
/* el-select 样式 */
#coupon >>> .el-input__inner {
  background: #f8f8f8;
  border: none;
  width: 360px !important;
}
.el-select-dropdown__item {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
}
.el-select-dropdown__list .selected {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
  color: #606266 !important;
}
.coupon .el-select-dropdown__item:hover {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
  background: #f8f8f8;
}

.coupon.el-input {
  display: inline !important;
}
.coupon .el-input input {
  display: block;
}
.coupon-order .txt {
  padding-right: 5px;
  display: block;
  width: 100%;
}
.txt1 {
  width: auto !important;
  padding-bottom: 5px;
}
.coupon .el-textarea__inner {
  background: #f8f8f8;
  width: 490px;
  border: none;
  min-height: 100px !important;
}

.coupon .inner-textarea {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 60px;
}

.coupon-button-primary button {
  color: #fff;
  font-weight: 700;
}
.coupon-button button {
  outline: none;
  background: none;
  border: none;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.element-col img {
  margin-top: 30px;
  width: 600px;
}

.qrcode-show{
  /* height: 400px; */
}
.qrcode-show >>> .el-dialog__title{
  display: inline-block;
  margin-top: 40px;
  /* width: 250px; */
  text-align: center;
}
.qrcode-show >>> .el-dialog__body{
  padding-top:0px;
}
.qrcode-show >>> .el-dialog__body img{
  margin-top:0px;
}

.sendCode {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  border: none;
  background: #f8f8f8;
  border-radius: 6px;
  margin-right: 186px;
}
#coupon .sendCode  >>> .el-input__inner {
  border: none;
  border-color: transparent;
  background: fixed;
  width: 100px !important;
  margin-top: 0px !important;
}
.sendCode span {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: rgba(23, 211, 161, 0.2);
  cursor: pointer;
  width: 80px;
}
.sendCode .active-txt2 {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: rgba(23, 211, 161);
  cursor: pointer;
  width: 80px;
}
.coupon-button {
  width: 100%;
  position: relative;
  font-weight: 700;
  font-size: 16px;
  color: #fff;
  letter-spacing: 1.6px;
  text-align: center;
  border-radius: 2px;
  height: 44px;
}
</style>



// WEBPACK FOOTER //
// src/components/comment/coupon.vue